export enum IncomeSource {
  AlimonyChildSupport = 'ALIMONY_CHILD_SUPPORT',
  Disability = 'DISABILITY',
  FullTime = 'FULL_TIME',
  Other = 'OTHER',
  PartTime = 'PART_TIME',
  Pension = 'PENSION',
  SelfEmployed = 'SELF_EMPLOYED',
}
